import React, { useState, useEffect  } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import {Row, Col} from 'react-bootstrap'


import Header from './Components/Header/Header'

import Login from './Components/Login/Login';
import Records from './Components/Records/Records';
import Dashboard from './Components/Dashboard/Dashboard';
import Categories from './Components/Categories/Categories';

const App = () => {
  const [user, setUser] = useState(() => {
    return localStorage.getItem('user') || null; 
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', user); 
    } else {
      localStorage.removeItem('user'); 
    }
  }, [user]);

  const handleLogin = (username) => {
    setUser(username);
  };

  const handleLogout = () => {
    setUser(null);
  };

  return (
    <Router>
      <Row className="m-0 h-100vh">
        {user &&
          <Col md="auto p-0">
           <Header user={user} onLogout={handleLogout} />
          </Col>      }
        <Col className=" p-5 main-content">
        {user ? (
          <Routes>
            <Route path="/dashboard" element={<Dashboard user={user} onLogout={handleLogout} />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Navigate to="/dashboard" replace />} />
             <Route path="/records/" element={<Records  />} />

             <Route path="/dashboard/records/create/" element={<Dashboard  user={user}/>} />
             <Route path="/records/create/" element={<Records  />} />
             <Route path="/records/edit/:id/" element={<Records  />} />
             <Route path="/records/view/:id/" element={<Records  />} />
            <Route path="/categories/" element={<Categories  />} />
            <Route path="/categories/create/" element={<Categories  />} />
            <Route path="/categories/edit/:id/" element={<Categories  />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
        </Col>
      </Row>
    </Router>
  );
};

export default App;
